var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgMail(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M23 5.983V18c0 1.652-1.348 3-3 3H4c-1.652 0-3-1.348-3-3V6.012v-.03A3.006 3.006 0 014 3h16a3.006 3.006 0 013 2.983zm-2.106-.43A1.006 1.006 0 0020 5H4c-.388 0-.728.227-.893.554L12 11.779l8.894-6.225zM21 7.922l-8.426 5.898a1 1 0 01-1.147 0L3 7.921V18c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V7.92z"
  }));
}

export default SvgMail;